/**
 * Upscale-Prüfung + Auto-Import eines Tasks, gemeinsam für die Import-Karte (AutoImportCountdown)
 * und die Info-Box im LiveEditor. `task.autoImport` schreibt der Server
 * (firebase_aq/functions-upscaler/src/autoImport.ts): scheduled | stopped | skipped | failed.
 */

/** Grund, warum der Task nicht automatisch importiert wird — auch ohne Server-Vermerk (Score, kein Job …); "" = kein Grund */
export function manualImportReason(task, customizationData) {
  const info = (task && task.autoImport) || null;
  if (info) {
    if (info.state === "stopped") return "von Hand gestoppt";
    if (info.state === "skipped") return info.reason || "ausgeschlossen";
    if (info.state === "failed") return `Auto-Import fehlgeschlagen: ${info.reason || "unbekannt"}`;
  }
  const cd = customizationData || (task && task.customizationData) || {};
  const up = cd.upscale || null;
  if (cd.upscaleError) return `Upscale fehlgeschlagen: ${cd.upscaleError}`;
  if (!up || !cd.upscaleJobId) return "kein Upscale-Job";
  const min = up.taskScore && up.taskScore.min !== null && up.taskScore.min !== undefined ? Number(up.taskScore.min) : null;
  const limit = Number(up.taskScoreLimit) || 85;
  if (up.passed !== true) {
    if (min === null) return "kein Score (Prüfung ohne Ergebnis)";
    return `Score ${min} unter ${limit}${up.taskScore && up.taskScore.limitedBy ? ` (${up.taskScore.limitedBy})` : ""}`;
  }
  if (!info) return "Auto-Import nicht eingeplant";
  return "";
}

/** Ergebnis der Upscale-Prüfung: { tone: ok|bad|none, title, detail } oder null ohne Upscale-Job */
export function upscaleVerdict(customizationData) {
  const cd = customizationData || {};
  const up = cd.upscale || null;
  if (cd.upscaleError) return { tone: "bad", title: "Upscale fehlgeschlagen", detail: cd.upscaleError };
  if (!up || !cd.upscaleJobId) return null;
  const min = up.taskScore && up.taskScore.min !== null && up.taskScore.min !== undefined ? Number(up.taskScore.min) : null;
  const limit = Number(up.taskScoreLimit) || 85;
  const by = up.taskScore && up.taskScore.limitedBy ? ` (${up.taskScore.limitedBy})` : "";
  if (up.passed === true) return { tone: "ok", title: "Prüfung bestanden", detail: min === null ? "" : `Score ${min} · Grenze ${limit}` };
  if (min === null) return { tone: "none", title: "Keine Prüfung", detail: "Prüfung ohne Ergebnis" };
  return { tone: "bad", title: "Prüfung nicht bestanden", detail: `Score ${min} unter ${limit}${by}` };
}
